<template>
  <div>
    <PageAllow controller="Settlements" action="purchaseIndex" />
    <Breadcrumbs :items="items" />
    <v-sheet class="transparent-background-color">
      <v-sheet class="transparent-background-color">
        <v-row dense class="mx-5">
          <v-col cols="12" sm="12" md="4">
            <v-row dense align="center" class="pa-1 pe-2">
              <SearcherDatetimeRangeWithRadio
                v-model="options"
                type="datetime"
                show-radios
                :radios="datetimeRadios"
                deleteIcon
                removeIcon
              />
            </v-row>
          </v-col>
          <v-col cols="12" sm="12" md="8" align-self="center">
            <v-row dense align="center" class="search-controls">
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="px-0 py-0 caption font-weight-bold grey--text"
                    color="primary"
                    @click.stop="onSearch()"
                  >
                    <v-icon small class="pe-1">fa-search</v-icon>
                    {{ $t("Search.search") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.searchTip") }}</span>
              </v-tooltip>
              <v-tooltip bottom>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn
                    v-bind="attrs"
                    v-on="on"
                    small
                    text
                    class="caption font-weight-bold grey--text"
                    @click.stop="resetSearch()"
                  >
                    <v-icon x-small class="pe-1">fa-trash-alt</v-icon>
                    {{ $t("Search.reset") }}
                  </v-btn>
                </template>
                <span>{{ $t("Search.resetTip") }}</span>
              </v-tooltip>
              <v-divider vertical />
              <v-btn
                class="caption font-weight-bold grey--text"
                :class="
                  $vuetify.theme.dark ? 'text--lighten-1' : 'text--darken-1'
                "
                small
                text
                @click.stop="$store.commit('toggleSearchPanel')"
              >
                  {{ $t("Search.pro") }}
                  <v-icon small class="ps-1">{{
                    $store.state.showSearchPanel ? "fa-angle-up" : "fa-angle-down"
                }}</v-icon>
              </v-btn>
              <v-spacer />
              <v-btn
                v-if="$permission.permissionAllow('Settlements', 'queueIndex')"
                small
                color="primary"
                class="elevation-1 ms-1"
                href="/#/settlements-purchase/queue"
              >
                {{ $t("SettlementQueue.objectName") }}
              </v-btn>
              <v-btn
                v-if="$permission.permissionAllow('Settlements', 'getPurchaseWaitSettleBills')"
                small
                color="primary"
                class="elevation-1 ms-1"
                href="/#/settlements-purchase/purchase-wait-settle-bills"
              >
                {{ $t("SettlementsPurchase.addBtn") }}
              </v-btn>
            </v-row>
          </v-col>
        </v-row>
        <v-expansion-panels
          v-model="$store.getters.panels"
          multiple
          flat
          accordion
        >
          <v-expansion-panel class="transparent-background-color">
            <v-expansion-panel-content>
              <v-row dense align="center">
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="shopUserNameKeyword"
                    v-model="options.shop_user_name"
                    @text="shopUserNameKeyword = $event"
                    :label="$t('SettlementsPurchase.receive_settlement')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="keyword"
                    v-model="options.keyword"
                    @text="keyword = $event"
                    :label="$t('SettlementsPurchase.pay_settlement')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherKeyword
                    ref="settlementCodeKeyword"
                    v-model="options.settlement_code"
                    @text="settlementCodeKeyword = $event"
                    :label="$t('SettlementsPurchase.Fields.settlement_code')"
                  />
                </v-col>
                <v-col cols="12" sm="6" md="4">
                  <SearcherStatus
                    v-model="options.status"
                    :label="$t('SettlementsPurchase.status.title')"
                    :items="$consts.settlement.status"
                  />
<!--                  <div-->
<!--                    class="caption grey&#45;&#45;text input-chip-group-label"-->
<!--                    :class="-->
<!--                      $vuetify.theme.dark ? 'text&#45;&#45;lighten-1' : 'text&#45;&#45;darken-1'-->
<!--                    "-->
<!--                  >-->
<!--                    {{ $t("SettlementsShop.status.title") }}-->
<!--                  </div>-->
<!--                  <v-radio-group row v-model="psiEnable">-->
<!--                    <v-radio-->
<!--                      :label="$t('SettlementsShop.status.all')"-->
<!--                      key="all"-->
<!--                      value="all"-->
<!--                    />-->
<!--                    <v-radio-->
<!--                      :label="$t('SettlementsShop.status.wait')"-->
<!--                      :key="0"-->
<!--                      :value="0"-->
<!--                    />-->
<!--                    <v-radio-->
<!--                      :label="$t('SettlementsShop.status.complete')"-->
<!--                      :key="1"-->
<!--                      :value="1"-->
<!--                    />-->
<!--                  </v-radio-group>-->
                </v-col>
              </v-row>
              <!-- 状态 -->
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
      </v-sheet>

      <!-- 汇总 -->
      <div class="mx-4 mb-4">
        <v-row>
          <v-col cols="12" sm="12">
            <v-card>
              <v-card-title>
                <h5>{{ $t("SettlementsPurchase.Fields.total") }}</h5>
              </v-card-title>
              <v-divider></v-divider>
              <v-list-item>
                <v-list-item-content>
                  {{ $t("SettlementsPurchase.Fields.fee")}}{{ $t("Global.colon") }}
                  {{ $t("Global.money")}}{{ fee_total | formatMoneyFloor(true) }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ $t("SettlementsPurchase.Fields.paid")}}{{ $t("Global.colon") }}
                  {{ $t("Global.money") }}{{ received_total | formatMoneyFloor(true) }}
                </v-list-item-content>
                <v-list-item-content>
                  {{ $t("SettlementsPurchase.Fields.wait_receive")}}{{ $t("Global.colon") }}
                  {{ $t("Global.money") }}{{ wait_receive_total | formatMoneyFloor(true) }}
                </v-list-item-content>
              </v-list-item>
            </v-card>
          </v-col>
        </v-row>
      </div>

      <div class="mx-4 mb-4">
        <v-data-table
          :headers="headers"
          :items="settlements"
          :loading="loading"
          :options.sync="options"
          :page.sync="paging.page"
          :server-items-length="paging.count"
          multi-sort
          class="elevation-2 px-4 pt-1 sticky-table"
          fixed-header
          :footer-props="$t('$config.footer-props')"
        >
          <template v-slot:header.actions="{ header }">
            {{ header.text }}
            <v-icon x-small>fa-sliders-h</v-icon>
          </template>
          <template v-slot:item.created="{ item }">
            {{ item.created | formatTime }}
          </template>
          <template v-slot:item.date="{ item }">
            {{ item.date_from | formatDate }} - {{ item.date_to | formatDate }}
          </template>
          <template v-slot:item.fee="{ item }">
            {{ $t("Global.money") }}{{ item.fee | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.paid="{ item }">
            {{ $t("Global.money") }}{{ item.paid | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.wait_receive="{ item }">
            {{ $t("Global.money") }}{{ item.wait_receive | formatMoneyFloor(true) }}
          </template>
          <template v-slot:item.status="{ item }">
            <v-chip
              small
              label
              :color="item.status | settlementStatusColor"
              :text-color="item.status | settlementStatusTextColor"
            >
              {{ item.status | settlementStatusText }}
            </v-chip>
            <v-chip
              v-if="item.edit_status == 1"
              small
              label
              class="ml-2"
              color="warning"
              text-color="white"
            >
              {{ $t("SettlementsPurchase.status.editing") }}
            </v-chip>
          </template>
          <template v-slot:item.actions="{ item }">
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('Settlements', 'purchaseMaterialView')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="$router.push('/settlements-purchase/material/' + item.id)"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("SettlementsPurchase.Fields.materialDetail") }}
                </v-btn>
              </template>
              <span>{{ $t("SettlementsPurchase.Fields.materialDetail") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="
                $permission.permissionAllow('Settlements', 'purchaseBillView')
              "
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="info"
                  class="px-2 me-2 mb-1"
                  @click.stop="$router.push('/settlements-purchase/bill/' + item.id)"
                >
                  <v-icon x-small class="pe-1">fa-align-left</v-icon>
                  {{ $t("SettlementsPurchase.Fields.billDetail") }}
                </v-btn>
              </template>
              <span>{{ $t("SettlementsPurchase.Fields.billDetail") }}</span>
            </v-tooltip>
            <v-tooltip
              top
              v-if="$permission.permissionAllow('Settlements', 'purchaseDetailExport')"
            >
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  small
                  dark
                  v-bind="attrs"
                  v-on="on"
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click="download(item.id)"
                >
                  <v-icon x-small class="pe-1">fa-file-export</v-icon>
                  {{ $t("Receipt.bill_details_export") }}
                </v-btn>
              </template>
              <span>{{ $t("Receipt.bill_details_export") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="$permission.permissionAllow('Settlements', 'purchaseCheck') && item.actions && item.actions.check">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="primary"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    current = item;
                    checkDialog = true
                  "
                >
                  {{ $t("SettlementQueue.Fields.check") }}
                </v-btn>
              </template>
              <span>{{ $t("SettlementQueue.Fields.check") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="$permission.permissionAllow('Settlements', 'purchaseRegenerate') && item.actions && item.actions.regenerate">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="action"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    current = item;
                    regenerateDialog = true
                  "
                >
                  {{ $t("SettlementQueue.Fields.regenerate") }}
                </v-btn>
              </template>
              <span>{{ $t("SettlementQueue.Fields.regenerate") }}</span>
            </v-tooltip>
            <v-tooltip top v-if="$permission.permissionAllow('Settlements', 'purchaseCancel') && item.actions && item.actions.cancel">
              <template v-slot:activator="{ on, attrs }">
                <v-btn
                  v-bind="attrs"
                  v-on="on"
                  small
                  dark
                  color="danger"
                  class="px-2 me-2 mb-1"
                  @click.stop="
                    current = item;
                    cancelDialog = true
                  "
                >
                  {{ $t("SettlementQueue.Fields.cancel") }}
                </v-btn>
              </template>
              <span>{{ $t("SettlementQueue.Fields.cancel") }}</span>
            </v-tooltip>
          </template>
        </v-data-table>
      </div>
    </v-sheet>
    <DialogAlert
      v-model="checkDialog"
      :title="$t('SettlementQueue.check')"
      :message="$t('SettlementQueue.checkConfirmMsg', [current ? current.settlement_code : ''])"
      useConfirm
      @confirm="check(current)"
    />
    <DialogAlert
      v-model="regenerateDialog"
      :title="$t('SettlementQueue.regenerate')"
      :message="$t('SettlementQueue.reRouterMsg')"
      useConfirm
      @confirm="$router.push('/settlements-purchase/queue?queue_code=' + current.queue_code)"
    />
    <DialogAlert
      v-model="cancelDialog"
      :title="$t('SettlementQueue.cancel')"
      :message="$t('SettlementQueue.reRouterMsg')"
      useConfirm
      @confirm="$router.push('/settlements-purchase/queue?queue_code=' + current.queue_code)"
    />
  </div>
</template>

<script>
import { mapState } from "vuex";
import PageAllow from "@/components/PageAllow";
import i18n from "@/i18n";
import Breadcrumbs from "@/components/Breadcrumbs";
import SearcherKeyword from "@/components/plugins/SearcherKeyword";
import Settlements from "@/api/settlements";
import SearcherStatus from "@/components/plugins/SearcherStatus.vue";
import SearcherDatetimeRangeWithRadio from "@/components/plugins/SearcherDatetimeRangeWithRadio.vue";
import DialogAlert from "@/components/plugins/DialogAlert.vue";
// import SearcherStatus from "@/components/plugins/SearcherStatus";

const defaultOptions = {
  datetimeRadioSelected: "created",
  created_time_from: new Date(new Date().getTime() - 30 * 24 * 3600 * 1000).toISOString().substr(0, 10) + " 00:00:00",
  created_time_to: new Date().toISOString().substr(0, 10) + " 23:59:59",
  keyword: "",
  shop_user_name: "",
  settlement_code: "",
  status: [1, 2, 3, 4, 5],
};

export default {
  data: () => ({
    keyword: "",
    shopUserNameKeyword: "",
    settlementCodeKeyword: "",
    options: JSON.parse(
      sessionStorage.getItem("settlements-purchase-options")
        ? sessionStorage.getItem("settlements-purchase-options")
        : JSON.stringify(defaultOptions)
    ),
    paging: {},
    settlements: [],
    fee_total: 0,
    received_total: 0,
    wait_receive_total: 0,
    current: null,
    checkDialog: false,
    regenerateDialog: false,
    cancelDialog: false,
  }),

  components: {
    DialogAlert,
    SearcherDatetimeRangeWithRadio,
    SearcherStatus,
    PageAllow,
    Breadcrumbs,
    SearcherKeyword,
    // SearcherStatus,
  },

  computed: {
    items: () => [
      {
        text: i18n.t("Nav.home"),
        disabled: false,
        href: "/home",
      },
      {
        text: i18n.t("Nav.settlements"),
        disabled: false,
        href: "/settlements-purchase",
      },
      {
        text: i18n.t("Nav.settlementsPurchase"),
        disabled: true,
        href: "/settlements-purchase",
      },
    ],

    headers() {
      return [
        {
          text: i18n.t("SettlementsPurchase.Fields.settlement_code"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "settlement_code",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.receive_settlement"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "receive_entity_name",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.pay_settlement"),
          align: "start",
          class: "text-no-wrap",
          sortable: false,
          value: "pay_entity_name",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.created"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "created",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.date"),
          align: "center",
          sortable: false,
          class: "text-no-wrap",
          value: "date",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.fee"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "fee",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.paid"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "paid",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.wait_receive"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "wait_receive",
        },
        {
          text: i18n.t("SettlementsPurchase.Fields.status"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "status",
        },
        {
          text: i18n.t("TableHeaders.actions"),
          align: "center",
          class: "text-no-wrap",
          sortable: false,
          value: "actions",
        },
      ];
    },

    datetimeRadios: () => [
      {
        key: "created",
        text: i18n.t("SettlementsPurchase.Fields.created"),
      },
    ],

    ...mapState(["loading", "settings"]),
  },

  mounted() {
    // this.$commonUtils
    //     .loadOptions("settlements-shop", [
    //       "alliancesSelected",
    //       "districtsSelected",
    //       "templateSelected",
    //     ])
    //     .then(
    //         function (data) {
    //           if (data.options) {
    //             this.options = data.options;
    //             if (this.options.psi_enable != undefined) {
    //               if (this.options.psi_enable === "") {
    //                 this.psiEnable = "all";
    //               } else {
    //                 this.psiEnable = this.options.psi_enable;
    //               }
    //             }
    //           } else this.resetSearch();
    //
    //           data.selecteds.forEach((selected) => {
    //             switch (selected.key) {
    //               case "alliancesSelected":
    //                 this.alliancesSelected = selected.value;
    //                 break;
    //               case "districtsSelected":
    //                 this.districtsSelected = selected.value;
    //                 break;
    //               case "templateSelected":
    //                 this.templateSelected = this.$route.query.template_id
    //                     ? { id: this.$route.query.template_id }
    //                     : selected.value;
    //                 break;
    //             }
    //           });
    //         }.bind(this)
    //     );
  },

  watch: {
    options: {
      deep: true,
      handler() {
        this.getSettlementsPurchaseFromAPI();
        sessionStorage.setItem(
          "settlements-purchase-options",
          JSON.stringify(this.options)
        );
      },
    },
  },

  methods: {
    onSearch() {
      this.options = Object.assign({}, this.options, {
        keyword: this.keyword,
        shop_user_name: this.shopUserNameKeyword,
        settlement_code: this.settlementCodeKeyword,
      });
    },
    resetSearch() {
      this.keyword = '';
      this.shopUserNameKeyword = '';
      this.settlementCodeKeyword = '';
      this.options = JSON.parse(JSON.stringify(defaultOptions));
      [this.$refs.keyword, this.$refs.shopUserNameKeyword, this.$refs.settlementCodeKeyword].forEach(
          (k) => {
            if (k) k.clear();
          }
      );
    },

    getSettlementsPurchaseFromAPI() {
      Settlements.fetchPurchase(this.options).then(
          function (response) {
            if (response.data.status.isOK()) {
              this.settlements = response.data.settlements;
              this.paging = response.data.paging;
              this.fee_total = response.data.fee_total;
              this.received_total = response.data.received_total;
              this.wait_receive_total = response.data.wait_receive_total;
            } else if (response.data.error.code.isNoResultSet()) {
              this.options.page = 1;
            }
          }.bind(this)
      );
    },
    download(id) {
      Settlements.purchaseDetailExport(id);
    },
    check(data) {
      Settlements.purchaseCheck(data.id).then(
        function (response) {
          if (response.data.status.isOK()) {
            this.$snackbar.success(i18n.t("SettlementQueue.checkSuccessMsg")); 
            this.getSettlementsPurchaseFromAPI();
          }
        }.bind(this)
      );
    }
  },
};
</script>

<style>
</style>